import { AuthState } from '@okta/okta-auth-js';
import { AppSettings } from 'src/AppSettings';
import { User } from 'src/Databases/index';

export const getUser = (authState: AuthState | null): User => {
  let groups = (authState?.idToken?.claims?.groups as [string]) ?? [];
  let user: User = {
    initials: getNameInitials(authState?.idToken?.claims?.name ?? ""),
    name: authState?.idToken?.claims?.name,
    email: authState?.idToken?.claims?.email,
    isAdmin: (AppSettings.oktaAdminGroup??"").trim().length===0 || groups.includes(AppSettings.oktaAdminGroup),
    powerUserGroup: AppSettings.oktaAdminGroup,
  };
  return user;
}

export const getNameInitials = (name: string): string => name
  .split(' ')
  .map(namePart => namePart.charAt(0))
  .join('')
  .toUpperCase();
